module.exports = __webpack_public_path__ + "static/900_450_crop-476e60389c0d27e33871952ea5ae0719.jpg";